var _defs, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_41437",
    "data-name": "Group 41437",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2565",
    d: "M0-682.665H17.5v17.5H0Z",
    transform: "translate(0 682.665)"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15705",
    "data-name": "Rectangle 15705",
    width: 20,
    height: 20,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "forward",
    transform: "translate(1.25 1.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2559"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2561"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2563",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2569",
    transform: "translate(0.511 2.615)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2571",
    d: "M-609.3-163.669l-3.963-3.963c-.6-.6-1.084-.394-1.084.449v1.769a11.069,11.069,0,0,0-10.983,9.711,10.562,10.562,0,0,1,8.54-4.338,10.6,10.6,0,0,1,2.443.287v1.769c0,.843.488,1.045,1.084.449l3.963-3.963A1.537,1.537,0,0,0-609.3-163.669Z",
    transform: "translate(625.332 167.975)",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForward);
export default __webpack_public_path__ + "static/media/forward.6033624447fe957625ed187d3360429e.svg";
export { ForwardRef as ReactComponent };